
import { getExpirationDate, getToken } from "./user";

const validateToken = () => {
    const timeStr = getExpirationDate();

    if (timeStr === null)
        return false
    if (timeStr.length === 0)
        return false

    let timestamp = timeStr;
    let date = new Date(timestamp * 1000);
    let formattedDate = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);

    if (formattedDate < new Date())
        return false;

    const token = getToken();

    if (token === null || token === undefined)
        return false;
    if (token.length === 0)
        return false
    return true;
}

export { validateToken }